module.exports = __webpack_public_path__ + "1bde5e7cec3cccef63b4cdaddcabaa.otf";